import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'reactstrap'

class PopupConfirm extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    className: PropTypes.string,
    centered: PropTypes.bool,
    fade: PropTypes.bool,
    eventName: PropTypes.string,
    respond: PropTypes.func
  }

  applyConfirm = (response) => {
    this.props.respond(response)
  }

  render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        className='ModalElemConfirm'
        centered={true}
        fade={true}
      >
        <div className='ElemConfirm'>
          <div className='header modal-header'>
            <h2 className='modal-title'>{this.props.title}</h2>
            <button
              type='button'
              className='close'
              aria-label='Close'
              onClick={() => {
                this.applyConfirm(false)
              }}
            >
              <i className='icon material-icons'></i>
            </button>
          </div>

          <div className='content p-4 py-5 modal-body'>
            {this.props.message}
          </div>

          <div className='p-4 modal-footer'>
            <span
              className='cancel'
              onClick={() => {
                this.applyConfirm(false)
              }}
            >
              Annuler
            </span>

            <span
              className='confirm'
              onClick={() => {
                this.applyConfirm(true)
              }}
            >
              Continuer
            </span>
          </div>
        </div>
      </Modal>
    )
  }
}

export default PopupConfirm
